import styled from 'styled-components';

export const LayoutWrapper = styled.div`
  width: 1440px;
  display: grid;
  padding: 16px;
  margin: 0 auto;
`;
